(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  // Function to lowercase only the mobile filter <select> options
  const lowerizeMobileFilters = () => {
    document.querySelectorAll("#filters-drawer option").forEach(option => {
      option.textContent = option.textContent.toLowerCase();
    });
  };

  // Run once on load
  lowerizeMobileFilters();

  // Run again when the mobile drawer opens (Shopify may re-render)
  const drawer = document.querySelector("#filters-drawer");
  if (drawer) {
    drawer.addEventListener("click", lowerizeMobileFilters);
  }
});
  } catch(e) { console.error(e); }
})();

})();
